import api from "@/api/api-v2-config";

export async function getInvoicesListAxios() {    
    return await api.get("invoices");
}

export async function getInvoicesIdAxios(id) {    
    return await api.get("invoices/"+ id);
}

export async function deleteInvoicesAxios(invoices) {    
    return await api.delete("invoices", invoices);
}

export async function postInvoicesAxios(invoices) {    
    return await api.post("invoices", invoices);
}

export async function putInvoicesAxios(invoices) {    
    return await api.put("invoices", invoices);
}

export async function putReturnInvoiceAxios(id) {    
    return await api.put(`invoices/return/${id}`);
}

export async function uploadInvoiceDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('invoices/invoice/files/upload', formData);
}

export async function uploadMultipleInvoiceDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('invoices/invoice/files/uploads', formData);
}

export async function getInvoiceDocumentAxios(ReferenceID) {
    return await api.get(`invoices/invoice/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}

export async function downloadInvoiceDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("invoices/invoice/files/download/" + id);
}

export async function deleteInvoiceDocument(id) {
    return await api.delete("invoices/invoice/files/" + id);
}